import {
	type ExperienceManifest,
	type ExperienceManifestId,
} from '../../common/types/experience/types';

let experienceService: ExperienceManifestRegistry | undefined;

export function getExperienceManifestRegistry(): ExperienceManifestRegistry {
	if (experienceService) {
		return experienceService;
	}
	experienceService = new ExperienceManifestRegistry();
	return experienceService;
}

export class ExperienceManifestRegistry {
	private experienceManifests: ExperienceManifest[] = [];

	registerExperienceManifest(experienceManifest: ExperienceManifest): void {
		this.experienceManifests.push(experienceManifest);
	}

	private safeIsUrlMatch(experience: ExperienceManifest, url: string): boolean {
		try {
			return experience.isUrlMatch(url);
		} catch {
			return false;
		}
	}

	getExperienceIdFromUrl(url: string): ExperienceManifestId | undefined {
		return this.experienceManifests.find((experience) => this.safeIsUrlMatch(experience, url))
			?.id;
	}

	getManifestByUrl(url: string): ExperienceManifest | undefined {
		return this.experienceManifests.find((experience) => this.safeIsUrlMatch(experience, url));
	}

	getManifestById(id: string): ExperienceManifest | undefined {
		return this.experienceManifests.find((experience) => experience.id === id);
	}

	getAllExperienceIds(): ExperienceManifestId[] {
		return this.experienceManifests.map((experience) => experience.id);
	}

	async getExperienceById(id: string): Promise<ExperienceManifest | undefined> {
		return this.experienceManifests.find((experience) => experience.id === id);
	}
}
